export default {
  PATH_MIGRATION: "migrate",
  PATH_NEW: "new",
  PATH_MIGRATION_UPDATE: "migrateUpdate",
  PATH_NEW_UPDATE: "newUpdate",

  // These need to be the same as the view files
  VIEW_CHOOSE_SETUP_TYPE: "ChooseSetupType",
  VIEW_SETUP_NOT_FOUND: "SetupNotFound",
  VIEW_PREFERRED_DOMAIN: "PreferredDomain",
  VIEW_CURRENT_BLOG_DOMAIN: "CurrentBlogDomain",
  VIEW_CURRENT_BLOG_LOGIN: "CurrentBlogLogin",
  VIEW_COMPLETE: "Complete",
  VIEW_CONFIRM: "Confirm",
  VIEW_UPDATE_START: "UpdateStart",

  SETUP_REQUEST_FIELDS: [
    "blog_url",
    "blog_domain_name",
    "blog_domain_email",
    "blog_migration_notes",
    "blog_admin_url",
    "blog_admin_user",
    "blog_admin_pass",
    "blog_should_activate_showit",
    "blog_registrar_name",
    "blog_registrar_url",
    "blog_registrar_user",
    "blog_registrar_pass",
    "blog_admin_verified",
    "blog_new_url",
  ],
};
